export default __webpack_public_path__ + "static/media/col.d2fc55ce.svg";